import { Tabs, Form } from "antd";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import moment from 'moment';
import { AddUser } from '../../style';
import CustomHtmlParser from '../../Email/CustomHtmlParser'
import { BasicFormWrapper } from '../../../styled';
import { DetailsOtherInfoUser } from '../GlobalComponents/UserCardCmnts'

const LeadTabPage = ({ displayData, }) => {
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const { TabPane } = Tabs;
    const [form] = Form.useForm();
    return (
        <AddUser>
            <div className="user-info-form">
                <Form style={{ width: '100%' }} form={form} name="info" colon={false}>
                    <BasicFormWrapper>
                        <div className="add-product-block">
                            <div className="add-product-content">
                                <Tabs defaultActiveKey="1">
                                    <TabPane tab="Task Info" key="1">
                                        <Form.Item label="Related to" name="taskType" className="custom-form-item">
                                            <span className="">{displayData?.task_type_name}</span>
                                        </Form.Item>
                                        <Form.Item label="Due Date" name="dueDate" className="custom-form-item">
                                            <span className="">{displayData !== undefined && displayData.due_date ? moment(displayData !== undefined && displayData.due_date).format(profile.dateFormate) : (displayData !== undefined && displayData.due_date && moment(displayData !== undefined && displayData.due_date).format("YYYY-MM-DD"))}</span>
                                        </Form.Item>
                                        <Form.Item label="Priority" name="priority" className="custom-form-item">
                                            <span className="">{displayData?.priority}</span>
                                        </Form.Item>
                                        <Form.Item label="Description" name="description" className="custom-form-item">
                                            <CustomHtmlParser html={displayData?.description} key={1} page="TextBoxs" />
                                        </Form.Item>
                                    </TabPane>
                                    <TabPane tab="Other Info" key="2">
                                        <Form.Item label="Created By" className="custom-form-item" >
                                            {displayData?.created_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.created_by,
                                                    recordbyFName: displayData?.createdByFirstName,
                                                    recordbyLName: displayData?.createdByLastName,
                                                    date: displayData?.created_at
                                                }} /> : <></>}
                                        </Form.Item>
                                        <Form.Item label="Modified By" className="custom-form-item">
                                            {displayData?.modified_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.modified_by,
                                                    recordbyFName: displayData?.modifiedByFirstName,
                                                    recordbyLName: displayData?.modifiedByLastName,
                                                    date: displayData?.modified_at
                                                }} /> : <></>}
                                        </Form.Item>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </BasicFormWrapper>
                </Form >
            </div>
        </AddUser >
    )
}
LeadTabPage.propTypes = {
    displayData: PropTypes.object.isRequired,
}
export default LeadTabPage;
